import { render } from "./MarketingPreferencesCampaigns.vue?vue&type=template&id=5fecde59&scoped=true"
import script from "./MarketingPreferencesCampaigns.vue?vue&type=script&lang=js"
export * from "./MarketingPreferencesCampaigns.vue?vue&type=script&lang=js"

import "./MarketingPreferencesCampaigns.vue?vue&type=style&index=0&id=5fecde59&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fecde59"]])

export default __exports__